type CompletedIconProps = {
  className?: string;
};

const CompletedIcon = (props: CompletedIconProps) => (
  <svg
    className={props.className !== undefined ? props.className : ""}
    width="13"
    height="9"
    viewBox="0 0 13 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.47896 5.12085C1.41556 5.04943 1.32639 5.00612 1.23106 5.00045C1.13574 4.99478 1.04206 5.02721 0.970642 5.09061C0.899224 5.15401 0.855917 5.24318 0.850245 5.3385C0.844574 5.43383 0.877004 5.52751 0.940402 5.59893L3.8204 8.83893C3.85297 8.87571 3.89271 8.90543 3.9372 8.92627C3.98168 8.94711 4.02996 8.95863 4.07906 8.96012C4.12816 8.9616 4.17705 8.95302 4.22271 8.9349C4.26837 8.91678 4.30984 8.88951 4.34456 8.85477L11.9046 1.29477C11.9722 1.22726 12.0102 1.13567 12.0102 1.04014C12.0103 0.944611 11.9724 0.852966 11.9049 0.785368C11.8374 0.717769 11.7458 0.679755 11.6503 0.679688C11.5548 0.67962 11.4631 0.717505 11.3955 0.785008L4.10408 8.07501L1.47824 5.12085H1.47896Z"
      fill="#158419"
    />
  </svg>
);

export default CompletedIcon;
